export default __webpack_public_path__ + "static/media/pizza.7dc6b66e.svg";